import { render } from "./culinary.vue?vue&type=template&id=794bceb1&scoped=true"
import script from "./culinary.vue?vue&type=script&lang=js"
export * from "./culinary.vue?vue&type=script&lang=js"

import "./culinary.vue?vue&type=style&index=0&id=794bceb1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-794bceb1"

export default script